<template>
    <v-snackbar
        v-model="snackBar.on"
        :timeout="snackBar.timeout"
        :color="snackBar.type"
        right
    >
        {{ snackBar.text }}
        <template v-if="snackBar.actionText" v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="onAction">
                {{ snackBar.actionText }}
            </v-btn>
        </template>
    </v-snackbar>
</template>

<script>
export default {
    name: "snackbar",
    components: {},
    props: [],
    data() {
        return {
            snackBar: {
                on: false,
                text: "My timeout is set to 2000.",
                timeout: 2000,
                type: "info",
                /// 有值時才出現動作按鈕；不傳就跟原本完全一樣
                actionText: "",
                action: null,
            },
        };
    },
    async created() {

    },
    watch: {
    },
    mounted() {

    },
    methods: {

        /**
         * @param {string} type Vuetify 的 color（`success` / `error` / `warning` / `info`）
         * @param {string} msg
         * @param {number} [timeout] 毫秒。⚠ **預設 2000，所以既有呼叫端完全不受影響。**
         *   長訊息要自己給——2 秒讀不完一句帶兩個數字的說明（例：素材重新上架後
         *   「還有 N 道題目被別的已下架素材卡住」，那是老師必須讀到的資訊）。
         */
        showAlertMsg(type, msg, timeout = 2000) {
            this.snackBar.type = type;
            this.snackBar.text = msg;
            this.snackBar.actionText = "";
            this.snackBar.action = null;
            this.snackBar.timeout = timeout;
            this.snackBar.on = true;
        },

        /// 帶動作按鈕的訊息（例：刪除後的「復原」）。
        /// 見 docs/plans/UnitTemplateEditor.web.spec.md §8：範圍小的破壞性操作用復原
        /// snackbar 而不是二次確認，因為「刪掉重寫」在編輯情境很常見。
        showActionMsg(type, msg, actionText, action, timeout = 8000) {
            this.snackBar.type = type;
            this.snackBar.text = msg;
            this.snackBar.actionText = actionText;
            this.snackBar.action = action;
            this.snackBar.timeout = timeout;
            this.snackBar.on = true;
        },

        onAction() {
            const action = this.snackBar.action;
            this.snackBar.on = false;
            this.snackBar.actionText = "";
            this.snackBar.action = null;
            if (typeof action === "function") {
                action();
            }
        },
    },
};
</script>
<style scoped>
</style>
